import curry from "./curry.js";

export default curry(function gte(a, b) {
  return a >= b;
});
